import { Dialog, RaisedButton } from "material-ui";
import React, { useState } from "react";
import colors from "../../styles/colors";
import LinearProgress from "material-ui/LinearProgress";
const styles = {
  button: {
    padding: 2,
    margin: 5,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
    width: 110,
  },
  disabledButton: {
    padding: 2,
    margin: 5,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
    width: 110,
  },
  icon: {
    borderStyle: "solid",
    borderColor: colors.steelBlue,
    backgroundColor: "white",
    borderWidth: 2,
    padding: 10,
    borderRadius: 40,
    height: 50,
    width: 50,
    margin: 2,
    marginTop: 5,
  },
  iconDisabled: {
    borderStyle: "solid",
    borderColor: colors.disabled,
    backgroundColor: "white",
    borderWidth: 2,
    padding: 10,
    borderRadius: 40,
    height: 50,
    width: 50,
    margin: 2,
    marginTop: 5,
  },
  textStyle: {
    color: colors.steelBlue,
    fontSize: 12,
    paddingTop: 5,
    alignContent: "center",
    justifyContent: "center",
    alignSelf: "center",
    textAlign: "center",
  },
  progressStyle: {
    color: colors.lightGrey,
    fontSize: 14,
    alignContent: "center",
    justifyContent: "center",
    alignSelf: "center",
    textAlign: "center",
    marginTop: "0",
  },
  disabledTextStyle: {
    color: colors.lightGrey,
    fontSize: 12,
    paddingTop: 5,
    alignContent: "center",
    alignSelf: "center",
    justifyContent: "center",
    textAlign: "center",
  },
  iconImg: {
    marginTop: 2,
    marginLeft: -2,
    width: 52,
    height: 45,
  },
  iconImgDisabled: {
    marginTop: 2,
    marginLeft: -2,
    width: 52,
    height: 45,
    opacity: 0.15,
  },
  modalView: {
    maxWidth: 400,
    alignItems: "center",
  },
  modalImg: {
    width: 70,
    display: "block",
    marginLeft: "auto",
    marginRight: "auto",
  },
  progressBarStyle: {
    height: "10px",
    color: colors.primary,
    borderRadius: "5px",
    marginBottom: "5px",
  },
  iconTextStyle: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  card: {
    height: 300,
    width: 300,
    borderStyle: "solid",
    borderRadius: 10,
    borderColor: "black",
    borderWidth: 1,
    padding: 15,
    boxShadow: "1px 3px 1px #9E9E9E",
  },
};

export default (props) => {
  const viewStyle = !props.disabled ? styles.button : styles.disabledButton;
  const cardStyle = styles.card;
  const textStyle = !props.disabled
    ? styles.textStyle
    : styles.disabledTextStyle;
  const iconImgStyle = !props.disabled
    ? styles.iconImg
    : styles.iconImgDisabled;
  const iconStyle = !props.disabled ? styles.icon : styles.iconDisabled;

  return (
    <div disabled={!!!props.info} style={{ ...viewStyle, ...cardStyle }}>
      <div style={styles.iconTextStyle}>
        <div style={iconStyle}>
          {props.img && <img src={props.img} style={iconImgStyle} />}
        </div>
        <p style={textStyle}>{props.title}</p>
        <p style={textStyle}>{props.info}</p>
      </div>
      <div>
        {props.progressType && (
          <LinearProgress
            mode="determinate"
            max={props.progressMax}
            value={props.progress}
            style={styles.progressBarStyle}
            color={"na"}
          />
        )}
        {props.progressType && props.progress !== null && (
          <p style={textStyle}>{props.progress + props.progressType}</p>
        )}
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/common/AwardDisplay.js